import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { useState, useCallback } from 'react';
import { defaultPasswordRegex } from '../../utils/validations.js';
import { Input } from '../input/input.component.js';

const defaultPasswordHelper = 'Must contain at least 8 characters and include a number';
const defaultLabel = 'Password';
const defaultName = 'password';
const defaultIconButtonAriaLabel = 'Toggle password visibility';
const PasswordInput = props => {
    const { requirementsText = defaultPasswordHelper, requirementsRegex = defaultPasswordRegex, label = defaultLabel, name = defaultName, iconButtonAriaLabel = defaultIconButtonAriaLabel, value } = props, inputProps = __rest(props, ["requirementsText", "requirementsRegex", "label", "name", "iconButtonAriaLabel", "value"]);
    const [showPassword, setShowPassword] = useState(false);
    const type = showPassword ? 'text' : 'password';
    const toggleShowPassword = useCallback(() => setShowPassword(previous => !previous), []);
    const iconType = showPassword ? 'EyeHidden' : 'Eye';
    const isValid = !!(value && requirementsRegex.test(value));
    const helperTextColor = isValid ? 'success' : 'secondary';
    return (jsx(Input, Object.assign({ label: label, name: name, helperText: requirementsText, helperTextColor: helperTextColor, value: value, type: type, iconButtonProps: {
            'aria-label': iconButtonAriaLabel,
            icon: iconType,
            onClick: toggleShowPassword,
        }, "data-sl": "mask" }, inputProps), void 0));
};

export { PasswordInput, defaultIconButtonAriaLabel, defaultLabel, defaultPasswordHelper };
